import React from 'react';

export const buildSwitchLinkStyle = (
  color?: string,
  hoverColor?: string,
  focusRingColor?: string,
  fontWeight?: string,
): React.CSSProperties | undefined =>
  color || fontWeight
    ? ({
        '--switch-link-color': color,
        '--switch-link-hover-color': hoverColor,
        '--switch-link-focus-ring-color': focusRingColor,
        '--wds-color-fill-standard-primary': color,
        '--wds-color-fill-standard-primary-hover': hoverColor,
        fontWeight,
      } as React.CSSProperties)
    : undefined;
